<div #pinRolesButton>
    <button adaptButtonIcon="pinBorderless"
            class="btn btn-primary btn-sm"
            [disabled]="popupVisible"
            (click)="popupVisible = true">Pin existing roles to team</button>
    <dx-popover [target]="pinRolesButton"
                [visible]="popupVisible"
                [hideOnOutsideClick]="false"
                height="auto"
                maxHeight="70vh">
        <div *dxTemplate="let data = model of 'content'"
             class="d-flex flex-column gap-2">
            <dx-tree-view [items]="treeViewDataSource"
                          selectionMode="multiple"
                          showCheckBoxesMode="normal"
                          selectAllText="Select all roles"
                          noDataText="No roles fit your search criteria"
                          [selectByClick]="true"
                          [searchEnabled]="true"
                          [useNativeScrolling]="true"
                          (onSelectionChanged)="onTreeViewSelectionChanged($event.component.getSelectedNodes())">
            </dx-tree-view>

            <div class="d-flex flex-row justify-content-evenly">
                <button adaptButtonIcon="pinBorderless"
                        class="btn btn-sm btn-primary flex-fill"
                        [disabled]="selectedRoles.length === 0"
                        [adaptBlockingClick]="onAddClicked"
                        [unsubscribeOnDestroy]="false"
                        data-test="pin-roles-button">Pin roles to team</button>
                <button adaptButton="cancel"
                        class="btn-sm flex-fill"
                        [disabled]="saving"
                        (click)="cancel()"></button>
            </div>
        </div>
    </dx-popover>
</div>
